import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  // Initialiser currentTab avec la valeur dans localStorage ou 0
  let currentTab = parseInt(localStorage.getItem("currentTab"), 10) || 0;
  console.log("currentTab depuis localStorage:", currentTab);

  // DOM Elements pour chaque section et tab links
  const websitesTitle = document.querySelector(".project-websites-link");
  const designTitle = document.querySelector(".project-design-link");
  const photoTitle = document.querySelector(".project-photo-link");
  const threeDTitle = document.querySelector(".project-3d-link");
  const gamesTitle = document.querySelector(".project-games-link");
  const videoTitle = document.querySelector(".project-video-link");

  const websitesProjects = document.querySelector("#websites-module");
  const designProjects = document.querySelector("#design-module");
  const photoProjects = document.querySelector("#photo-module");
  const threeDProjects = document.querySelector("#threeD-module");
  const gamesProjects = document.querySelector("#game-module");
  const videoProjects = document.querySelector("#video-module");

  // Fonction pour actualiser l'affichage des modules
  const updateTabDisplay = () => {
    // Cacher tous les modules avec animation GSAP
    const allModules = [
      websitesProjects,
      designProjects,
      photoProjects,
      threeDProjects,
      gamesProjects,
      videoProjects,
    ];
    const allTitles = [
      websitesTitle,
      designTitle,
      photoTitle,
      threeDTitle,
      gamesTitle,
      videoTitle,
    ];

    // Animation de disparition avec GSAP
    allModules.forEach((module) => {
      module.classList.add("l-module-hidden");
    });

    // Réinitialiser les titres pour enlever les classes actives
    allTitles.forEach((title) =>
      title.classList.remove("projects-page-title-active")
    );

    // Afficher le module correspondant à currentTab avec animation d'apparition
    switch (currentTab) {
      case 1:
        websitesProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          websitesProjects,
          {
            opacity: 0, // Démarrer l'élément avec une opacité de 0
            y: 400, // Début du mouvement, 50px en bas
          },
          {
            opacity: 1, // Terminer avec une opacité de 1
            y: 0, // Fin du mouvement, position d'origine
            duration: 0.5, // Durée de l'animation
          }
        );
        websitesTitle.classList.add("projects-page-title-active");
        break;
      case 2:
        designProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          designProjects,
          {
            opacity: 0,
            y: 400,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        );
        designTitle.classList.add("projects-page-title-active");
        break;
      case 3:
        photoProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          photoProjects,
          {
            opacity: 0,
            y: 400,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        );
        photoTitle.classList.add("projects-page-title-active");
        break;
      case 4:
        threeDProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          threeDProjects,
          {
            opacity: 0,
            y: 400,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        );
        threeDTitle.classList.add("projects-page-title-active");
        break;
      case 5:
        gamesProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          gamesProjects,
          {
            opacity: 0,
            y: 400,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        );
        gamesTitle.classList.add("projects-page-title-active");
        break;
      case 6:
        videoProjects.classList.remove("l-module-hidden");
        gsap.fromTo(
          videoProjects,
          {
            opacity: 0,
            y: 400,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        );
        videoTitle.classList.add("projects-page-title-active");
        break;
      default:
        break;
    }
  };

  // Initialiser l'affichage basé sur currentTab
  updateTabDisplay();

  // Mettre à jour currentTab et l'affichage lorsque l'un des titres est cliqué
  websitesTitle.addEventListener("click", () => {
    currentTab = 1;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  designTitle.addEventListener("click", () => {
    currentTab = 2;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  photoTitle.addEventListener("click", () => {
    currentTab = 3;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  threeDTitle.addEventListener("click", () => {
    currentTab = 4;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  gamesTitle.addEventListener("click", () => {
    currentTab = 5;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  videoTitle.addEventListener("click", () => {
    currentTab = 6;
    localStorage.setItem("currentTab", currentTab);
    updateTabDisplay();
  });

  console.log(currentTab);
});
